<footer class="py-6">
    <p class="footer-text text-center">
        &copy; {{ currentYear() }} {{ 'shared.footer.copyRight' | translate }}
        <br />
        {{ 'shared.footer.allRightsReserved' | translate }}
    </p>
</footer>
